import Divider from '@material-ui/core/Divider'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useTranslation } from 'react-i18next'

import { countries } from 'src/data/countries'

const useStyles = makeStyles((theme) => ({
	autocompleteOption: {
		'&[aria-disabled="true"]': {
			opacity: 1,
		},
		'& hr': {
			width: '100%',
		},
	},
}))

function CountriesAutoComplete({
	props,
	required,
	handleChange,
	smallSize,
	label,
}: {
	props?: any
	required: boolean
	handleChange: (data: any) => void
	smallSize: boolean
	label?: string
}) {
	const classes = useStyles()
	const { t: tContacts } = useTranslation('contacts')

	return (
		<Autocomplete
			id="combo-box-demo"
			{...props}
			fullWidth
			size="small"
			options={countries.map((c) => c.name)}
			classes={{
				option: classes.autocompleteOption,
			}}
			getOptionLabel={(option) =>
				countries
					?.filter((c) => c.name === option)
					.map((c) => `${c.name}(${c.code})`)[0]
			}
			renderOption={(option) => {
				return countries
					?.filter((c) => c.name === option)
					.map((c) => `${c.name}(${c.code})`)[0]
			}}
			renderInput={(params) => (
				<>
					<TextField
						{...params}
						label={
							label ||
							tContacts(
								'addContactsModal.sections.sectionThree.country'
							)
						}
						variant="outlined"
						fullWidth
						size={smallSize ? 'small' : 'medium'}
						required={required}
					/>
				</>
			)}
			onChange={(_, data) => {
				return handleChange(data)
			}}
		/>
	)
}

export default CountriesAutoComplete
